<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vi"></a><strong>CONTENTS</strong></p>
<p class="toc"><a href="#/html/9780226925233_05_int#int"><em>Introduction: Execrable Media</em></a></p>
<p class="toc"><em>Alexander R. Galloway, Eugene Thacker, McKenzie Wark</em></p>
<p class="toct"><span href="#/html/9780226925233_06_ch1#ch1" title="Link target outside of Sample">LOVE OF THE MIDDLE</span></p>
<p class="toc">Alexander R. Galloway</p>
<p class="toct"><span href="#/html/9780226925233_07_ch2#ch2" title="Link target outside of Sample">DARK MEDIA</span></p>
<p class="toc">Eugene Thacker</p>
<p class="toct"><span href="#/html/9780226925233_08_ch3#ch3" title="Link target outside of Sample">FURIOUS MEDIA: A QUEER HISTORY OF HERESY</span></p>
<p class="toc">McKenzie Wark</p>
<p class="toct"><span href="#/html/9780226925233_09_not" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226925233_04_toc.vue?2b6c6f31